module.exports = __webpack_public_path__ + "static/media/education.d0168a48.png";